export const UPDATE_RESPONSIVE_QUERIES = 'UPDATE_RESPONSIVE_QUERIES';

export const updateResponsiveQueryValues = queries => ({
  type: UPDATE_RESPONSIVE_QUERIES,
  queries
});



// WEBPACK FOOTER //
// ./src/client/js/store/actions/responsive.js